(() => {
  if (window.haimaSideCart) return;
  window.haimaSideCart = true;
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  const scope = () => document.querySelector('[data-haima-bundle-product-id]');
  const root = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  let returnFocus;
  let lockedScroll = false;

  const stop = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  function error(message, form) {
    let box = form?.querySelector('.product-form__error-message-wrapper');
    if (box) {
      box.hidden = !message;
      box.querySelector('.product-form__error-message').textContent = message;
      return;
    }
    const drawer = document.querySelector('cart-drawer .drawer__inner');
    if (!drawer) return;
    box = drawer.querySelector('[data-haima-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.dataset.haimaCartError = '';
      box.setAttribute('role', 'alert');
      drawer.prepend(box);
    }
    box.textContent = message;
    box.hidden = !message;
  }
  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!drawer.classList.contains('active')) {
      returnFocus = document.activeElement;
      lockedScroll = !document.body.classList.contains('overflow-hidden');
    }
    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    drawer.querySelector('.drawer__close, [role="dialog"]')?.focus();
  }
  function closeDrawer() {
    document.querySelector('cart-drawer')?.classList.remove('active');
    if (lockedScroll) document.body.classList.remove('overflow-hidden');
    returnFocus?.focus();
  }
  async function renderCart(sections) {
    if (typeof sections?.['cart-drawer'] !== 'string') {
      const response = await fetch(`${root()}?sections=${sectionIds.join(',')}`);
      if (!response.ok) throw new Error('Unable to refresh the cart. Please try again.');
      sections = await response.json();
    }
    const parser = new DOMParser();
    const html = parser.parseFromString(sections['cart-drawer'] || '', 'text/html');
    const fresh = html.querySelector('cart-drawer');
    if (!fresh?.querySelector('#CartDrawer')) throw new Error('Unable to refresh the cart. Please try again.');
    let drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      drawer = document.importNode(fresh, true);
      document.body.append(drawer);
    } else {
      drawer.querySelector('#CartDrawer').innerHTML = fresh.querySelector('#CartDrawer').innerHTML;
      drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    }
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const content = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (content) bubble.innerHTML = content.innerHTML;
    }
    openDrawer();
  }
  async function requestCart(path, body) {
    // Preserve Kaching's fetch integration: it supplies both variant IDs and discounts.
    const response = await fetch(`${root()}cart/${path}.js`, {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to update the cart. Please try again.');
    return result;
  }
  async function add(form) {
    const button = form.querySelector('[name="add"]');
    if (busy || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const productForm = form.closest('product-form');
    const bundle = scope().querySelector('kaching-bundles-block');
    if (bundle?.validateItemSelection && !bundle.validateItemSelection().valid) return;
    busy = true;
    error('', productForm);
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const spinner = button.querySelector('.loading-overlay__spinner');
    spinner?.classList.remove('hidden');
    let added = false;
    try {
      const body = new FormData(form);
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', location.pathname);
      const result = await requestCart('add', body);
      added = true;
      await renderCart(result.sections);
    } catch (failure) {
      error(added ? 'Your items were added. Open the cart icon to view them.' : failure.message, productForm);
    } finally {
      busy = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  }
  async function change(line, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    error('');
    const drawer = document.querySelector('cart-drawer');
    drawer.setAttribute('aria-busy', 'true');
    try {
      const body = new FormData();
      body.set('line', line);
      body.set('quantity', quantity);
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', location.pathname);
      const result = await requestCart('change', body);
      await renderCart(result.sections);
    } catch (failure) {
      error(failure.message);
    } finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
    }
  }

  // Capture clicks as well as keyboard submits, before theme/app redirect handlers.
  window.addEventListener('click', (event) => {
    if (!scope() || !(event.target instanceof Element)) return;
    const target = event.target;
    const addButton = target.closest('[data-haima-bundle-product-id] .main-product-form [name="add"]');
    if (addButton) { stop(event); void add(addButton.form); return; }
    if (target.closest('#cart-icon-bubble')) {
      stop(event);
      openDrawer();
      void renderCart().catch((failure) => error(failure.message));
      return;
    }
    if (!target.closest('cart-drawer')) return;
    if (target.closest('.drawer__close, #CartDrawer-Overlay')) { stop(event); closeDrawer(); return; }
    const remove = target.closest('cart-remove-button');
    if (remove) { stop(event); void change(remove.dataset.index, 0); return; }
    const button = target.closest('.quantity__button');
    if (button) {
      stop(event);
      const input = button.closest('quantity-input').querySelector('input');
      const next = Number(input.value) + (button.name === 'plus' ? 1 : -1) * Number(input.step || 1);
      if (next < Number(input.min || 0) || (input.max && next > Number(input.max))) return;
      void change(input.dataset.index, next);
    }
  }, true);
  window.addEventListener('submit', (event) => {
    if (scope() && event.target.matches('.main-product-form form')) { stop(event); void add(event.target); }
  }, true);
  window.addEventListener('change', (event) => {
    if (scope() && event.target.matches('cart-drawer input[name="updates[]"]')) {
      stop(event);
      void change(event.target.dataset.index, Number(event.target.value));
    }
  }, true);
  window.addEventListener('keydown', (event) => {
    if (!scope()) return;
    const drawer = document.querySelector('cart-drawer.active');
    if (!drawer) return;
    if (event.key === 'Escape') { stop(event); closeDrawer(); }
    if (event.key !== 'Tab') return;
    const items = [...drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select, [tabindex="0"]')]
      .filter((element) => element.getClientRects().length);
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { stop(event); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { stop(event); first?.focus(); }
  }, true);
})();
